import { GetSymbolsUrl } from '../constants';
import _ from 'lodash';
export function GetSymbols(api) {
    return (query, limit = 10) => {
        const querystringRequest = _.isString(query)
            ? {
                query,
                limit,
            }
            : query;
        return api
            .authenticated()
            .get(GetSymbolsUrl, querystringRequest, {
            headers: { Accept: 'application/json' },
        })
            .then((res) => res.payload || [])
            .catch(reason => {
            console.error('Error trying to fetch symbols', reason);
            return [];
        });
    };
}
export function Symbols(api) {
    return {
        search: (query, limit = 10) => {
            const querystringRequest = _.isString(query)
                ? {
                    query,
                    limit,
                }
                : query;
            return api
                .authenticated()
                .get(GetSymbolsUrl, querystringRequest, {
                headers: { Accept: 'application/json' },
            })
                .then((res) => res.payload || [])
                .catch(reason => {
                console.error('Error trying to fetch symbols', reason);
                return [];
            });
        },
        warnings: () => {
            return api.authenticated().get('Symbol/WarningSymbols', {}, {
                headers: { Accept: 'application/json' },
            });
        },
    };
}
//# sourceMappingURL=symbols.js.map